module.exports = __webpack_public_path__ + "static/media/sophisticated-1.37e1d0ad.png";